import { MessageRequest, MessageResponse } from '../core';

let opid = 0;

export function getUniqueOpid(): string {
  return `opid-${Date.now()}-${opid++}`;
}

export function filterByOpid() {
  let newOpid = getUniqueOpid();

  return function (msg1: MessageRequest | MessageResponse, msg2: MessageResponse): boolean {
    try {
      if (msg1 instanceof MessageRequest && msg1.request.opid === msg2.response.opid) {
        if (msg2.response.data.new_opid) {
          newOpid = msg2.response.data.new_opid;
        } else {
          return true;
        }

        return false;
      }

      return newOpid === msg2.response.opid;
    } catch (e) {
      return false;
    }
  };
}
